/**
 * `tarii.signup_product` — the product answer stash (#2630).
 *
 * The question on `/start` runs before sign-up. The chosen product key is
 * kept in `sessionStorage` beside `tarii.signup_intent` so it survives the
 * Clerk sign-up round trip. Onboarding reads it when the lead creates the
 * team and clears it once the team exists.
 */

import { type ProductKey, productByKey } from "./products";

export const SIGNUP_PRODUCT_KEY = "tarii.signup_product";

export const SIGNUP_PRODUCT_NOTE_KEY = "tarii.signup_product_note";

/** `note` is the "Something else" free-text line. It stays in the browser. */
export function stashSignupProduct(key: ProductKey, note?: string): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(SIGNUP_PRODUCT_KEY, key);
    if (note?.trim()) window.sessionStorage.setItem(SIGNUP_PRODUCT_NOTE_KEY, note.trim());
    else window.sessionStorage.removeItem(SIGNUP_PRODUCT_NOTE_KEY);
  } catch {
    // Storage unavailable: the lead gets today's flow.
  }
}

/** Read without clearing. Returns null for a missing or unknown key. */
export function peekSignupProduct(): ProductKey | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(SIGNUP_PRODUCT_KEY);
    return productByKey(raw)?.key ?? null;
  } catch {
    return null;
  }
}

export function clearSignupProduct(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(SIGNUP_PRODUCT_KEY);
    window.sessionStorage.removeItem(SIGNUP_PRODUCT_NOTE_KEY);
  } catch {
    /* no-op */
  }
}
